import React from 'react';
import {
  Colors,
  ColorsType,
  FontSize,
  FontWeight,
  LineHeight,
} from '@common/tokens';

export const Tag = ({
  children,
  color,
  ...props
}: {
  children: React.ReactNode;
  color: ColorsType;
}) => {
  const colorCode = Colors[color];

  return (
    <>
      <span className="wk-tag" {...props}>
        {children}
      </span>
      <style jsx>{`
        .wk-tag {
          display: inline-block;
          white-space: nowrap;
          border-radius: 12px;
          color: ${Colors.midnightDarker};
          background-color: ${colorCode};
          font-weight: ${FontWeight.bold};
          font-size: ${FontSize.xs};
          padding: 0 8px;
          line-height: ${LineHeight.sm};
          border: 1px solid transparent;
        }
      `}</style>
    </>
  );
};
